<template>
	<div>
		<header class="lmy-header">
	        <!-- <i class="iconfont icon-back"></i> -->
	    </header>
	    <div class="lmy-login-main">
	        <div class="lmy-login-btn" @click="$router.push('/login')">登录</div>
	    </div>
	</div>
</template>
<script>
	export default{
		name:'log-out',
	}
</script>


// WEBPACK FOOTER //
// src/components/usr/logOut.vue